<script setup>
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    deafault: 'md',
  },
  liquid: {
    type: Boolean,
    deafult: false,
  },
  theme: {
    type: String,
    deafault: 'fill',
  },
  ring: {
    type: String,
    deafault: 'red',
  },
  type: {
    type: String,
    default: 'submit',
  },
  customClass: {
    type: String,
    default: '',
  },
})
const emits = defineEmits(['onClick'])
const ringClasses = computed(() => {
  switch (props.ring) {
    case 'none':
      return ''
    case 'green':
      return 'ring-green-500/25 hover:ring-4'
    case 'blue':
      return 'ring-[#202edd]/25 hover:ring-4'
    case 'cyan':
      return 'ring-cyan-400/25 hover:ring-4'
    default:
      return 'ring-secondary-red-100/25 hover:ring-4'
  }
})

const themeClasses = computed(() => {
  switch (props.theme) {
    case 'outline':
      return 'border border-secondary-red-100 text-secondary-red-100'
    case 'outline-cyan':
      return 'border border-cyan-400 text-cyan-400'
    case 'outline-green':
      return 'border border-green-500 text-green-500'
    case 'outline-blue':
      return 'border border-blue-700 text-blue-700'
    case 'text':
      return 'text-primary !p-0 !ring-0'
    case 'green':
      return 'bg-green-500 text-white'
    case 'cyan':
      return 'bg-cyan-400 text-white'
    case 'none':
      return '!text-white'
    default:
      return 'bg-red-gradient !text-white'
  }
})

const paddingClasses = computed(() => {
  switch (props.size) {
    case 'xs':
      return 'px-3 py-1 !leading-4'
    case 'sm':
      return 'px-3.5 py-2'
    case 'lg':
      return 'px-6 py-3'
    case 'xl':
      return 'px-6.5 py-4'
    default:
      return 'px-4 py-3'
  }
})

const textFontSize = computed(() => {
  switch (props.size) {
    case 'xs':
      return 'text-[13px]'
    case 'sm':
      return 'text-sm'
    case 'lg':
      return 'text-lg'
    case 'xl':
      return 'text-xl'
    default:
      return 'text-md'
  }
})

const defaultWidth = computed(() => {
  switch (props.size) {
    case 'xs':
      return 'min-h-[39px]'
    default:
      return 'w-auto'
  }
})

const classes = computed(() => `${ringClasses.value} ${themeClasses.value} ${paddingClasses.value} ${props.liquid ? 'w-full' : defaultWidth.value}`)

function handleClick(event) {
  emits('onClick', event)
}
</script>

<template>
  <button
    class="font-semibold leading-6 transition-shadow duration-200 ease-in-out disabled:cursor-not-allowed disabled:opacity-50"
    :disabled="props.disabled" :class="[classes, customClass]" :type="type" @click="handleClick"
  >
    <span :class="textFontSize">
      <slot />
    </span>
  </button>
</template>
